<template>
  <div class="mt-4">
    <ul v-if="variants.length" class="variant-values">
      <li v-for="(variant, key) in variants" :key="key">
        <span> {{ variant }}</span>
        <span @click="removeAnswer(key)" class="ti-close"></span>
      </li>
    </ul>
    <div v-else><h5>Нет вариантов</h5></div>
    <hr />
    <div>
      <h5>Добавить вариант</h5>
      <input class="form-control" v-model="answer" />
      <button @click="addVariant()" class="btn btn-sm my-4 add-point-button">
        {{ "Добавить ответ" }}
      </button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "Dropdown",
  components: { draggable },

  props: {
    value: Array,
  },

  data() {
    return {
      variants: [],
      answer: "",
    };
  },
  created() {
    this.variants = Array.isArray(this.value) ? this.value : [];
  },
  methods: {
    addVariant() {
      if (!this.answer) {
        alert("Введите слово");
        return false;
      }
      this.variants.push(this.answer);
      this.answer = "";
      setTimeout(() => {
        this.$emit("input", this.variants);
      }, 1);
    },
    removeAnswer(index) {
      this.variants.splice(index, 1);
      setTimeout(() => {
        this.$emit("input", this.variants);
      }, 1);
    },
  },
};
</script>

<stype lang="scss">
ul.variant-values {
  display: flex;
  flex-wrap: wrap;
  & > li {
    padding: 5px 10px;
    display: flex;
    align-items: center;
    margin-right: 5px;
    background: #ebebeb;
    & span {
      display: block;
      &:first-child {
        margin-right: 5px;
      }
    }
  }
}
</stype>
